import { z } from 'zod';
import { LocaleSchema } from './specialization';

/**
 * Self-service account deletion (ADR-012) — App Store 5.1.1(v) / Play Data
 * Safety requirement. Two-step flow: request (starts a grace period, fully
 * reversible) → finalization (anonymization, done by an operator script
 * once the grace period elapses, never directly by this API).
 */

/** PATCH /api/v1/account/locale (ADR-015) — any authenticated role. Persists the UI-language preference so emails/notifications reach the user in the right language regardless of device. */
export const UpdateLocaleRequestSchema = z.object({
  preferredLocale: LocaleSchema,
});
export type UpdateLocaleRequest = z.infer<typeof UpdateLocaleRequestSchema>;

export const UpdateLocaleResponseSchema = z.object({
  preferredLocale: LocaleSchema,
});
export type UpdateLocaleResponse = z.infer<typeof UpdateLocaleResponseSchema>;

/** POST /api/v1/account/deletion-request — re-auth with current password, like any destructive account action. */
export const RequestAccountDeletionSchema = z.object({
  password: z.string().min(1).max(200),
  reason: z.string().max(500).optional(),
});
export type RequestAccountDeletionInput = z.infer<typeof RequestAccountDeletionSchema>;

export const AccountDeletionStatusSchema = z.object({
  /** null when no deletion is pending. */
  deletionRequestedAt: z.string().datetime().nullable(),
  /** deletionRequestedAt + the grace period — when finalization becomes eligible. null when not pending. */
  scheduledFinalizationAt: z.string().datetime().nullable(),
  graceDays: z.number().int().positive(),
});
export type AccountDeletionStatus = z.infer<typeof AccountDeletionStatusSchema>;

/** Shared response shape for the request/cancel/status endpoints. */
export const AccountDeletionStatusResponseSchema = z.object({
  deletion: AccountDeletionStatusSchema,
});
export type AccountDeletionStatusResponse = z.infer<typeof AccountDeletionStatusResponseSchema>;
